/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import {
    GraphQLObjectType as ObjectType,
    GraphQLString as StringType,
    GraphQLID as ID,
    GraphQLNonNull as NonNull,
    GraphQLList as List,
} from 'graphql';

const Cat = new ObjectType({
    name: 'CatItem',
    description: 'Cet objet represente une catégorie',
    fields: () => ({
        id: {
            type: new NonNull(ID),
            description: 'Le id de la catégorie',
            resolve: (obj) => obj.term_id
        },
        slug: {
            type: StringType,
            description: 'Le slug de la catégorie',
            resolve: (obj) => obj.slug
        },
        name: {
            type: StringType,
            description: 'Le nom de la catégorie',
            resolve: (obj) => obj.name
        },
    }),
});



const PostType = new ObjectType({
    name: 'PostItem',
    description: 'Cet objet represente un post',
    fields: () => ({
        id: {
            type: new NonNull(ID),
            description: 'Le id du post',
            resolve: (root) => root.id
        },
        slug: {
            type: StringType,
            description: 'Le slug du post',
            resolve: (root) => root.slug
        },
        title: {
            type: StringType,
            description: 'Le titre du post',
            resolve: (root) => root.title.rendered
        },
        titlePost: {
            type: StringType,
            description: 'Le titre du post',
            resolve: (root) => root.acf.titre_article
        },
        content: {
            type: StringType,
            description: 'Le content du post',
            resolve: (root) => root.content.rendered
        },
        excerpt: {
            type: StringType,
            description: 'Le résumé du post',
            resolve: (root) => root.acf.extrait_article
        },
        thumbnail: {
            type: StringType,
            description: 'Le thumbnail du post',
            resolve: (root) => root.acf.image_article.url
        },
        thumbAccueil1: {
            type: StringType,
            description: 'Le petit thumbnail accueil',
            resolve: (root) => root.acf.thumbnail_400x266.url
        },
        thumbAccueil2: {
            type: StringType,
            description: 'Le grand thumbnail accueil',
            resolve: (root) => root.acf.thumbnail_580x386.url
        },
        categories: {
            type: new List(Cat),
            description: 'Les categories du post',
            resolve: (root) => root.acf.categorie_article,
            fields: () => ({
                id: {
                    type: new NonNull(ID),
                    description: 'Le id de la catégorie',
                    resolve: (obj) => obj.term_id
                },
                slug: {
                    type: StringType,
                    description: 'Le slug de la catégorie',
                    resolve: (obj) => obj.slug
                },
                name: {
                    type: StringType,
                    description: 'Le nom de la catégorie',
                    resolve: (obj) => obj.name
                },
            }),
        },
        date: {
            type: StringType,
            description: 'La date du post',
            resolve: (root) => root.acf.date_article
        },
        authorName: {
            type: StringType,
            description: 'Le nom complet de l`auteur post',
            resolve: (root) => root.acf.auteur_article.display_name
        },
        authorAvatar: {
            type: StringType,
            description: 'Le nom de l`auteur post',
            resolve: (root) => root.acf.auteur_article.user_avatar
        },
        lienSociaux: {
            type: StringType,
            description: 'Les lien sociaux de l`auteur post',
            resolve: (root) => root.acf.lien_sociaux
        },
        ogImage: {
            type: StringType,
            description: 'Les lien sociaux de l`auteur post',
            resolve: (root) => root.acf.image_facebook.url
        },
    }),
});

export default PostType;



// WEBPACK FOOTER //
// ./data/types/PostType.js